export default __webpack_public_path__ + "assets/icons/qq.7203f18c.svg";